import { UserAuthorizationRequestInterface } from '../../interfaces/api';
import { LoginResponse } from '../../types/api';
import { phpApi } from '../default';

export const loginRequest: (data: UserAuthorizationRequestInterface) => Promise<LoginResponse> = (
  data: UserAuthorizationRequestInterface
): Promise<LoginResponse> => phpApi.post(
  '/api/user/login', data, { withCredentials: true }
);

export const logoutRequest: () => Promise<void> = (): Promise<void> => phpApi.post(
  '/api/user/logout'
);
